import { Review } from "../../../../types/types";

export enum ReviewTypeEnum {
  RECEIVED = "RECEIVED",
  GIVEN = "GIVEN",
}

export type ReviewType = keyof typeof ReviewTypeEnum;

export interface ReviewsResponse {
  data: {
    items: Review[];
    total: number;
  };
  message: string;
}
